import React from 'react';
import { AlertTriangle, RefreshCw } from 'lucide-react';
/**
 * Per-tab error boundary UI: renders children normally, or an inline
 * "failed to load" card with a retry button when the tab query errored.
 */
export const TabSection = ({ error, onRetry, isLoading = false, children, }) => {
    if (error && !isLoading) {
        return (React.createElement("div", { className: "flex flex-col items-center justify-center gap-3 rounded-xl border border-gray-200 bg-white py-16 text-center" },
            React.createElement(AlertTriangle, { className: "h-10 w-10 text-red-500" }),
            React.createElement("p", { className: "font-medium text-red-600" }, "Failed to load dashboard data"),
            React.createElement("p", { className: "text-sm text-gray-500" }, error.message),
            onRetry && (React.createElement("button", { type: "button", onClick: onRetry, className: "inline-flex items-center rounded-lg border border-gray-300 bg-white px-3 py-1.5 text-sm font-medium text-gray-700 hover:bg-gray-50" },
                React.createElement(RefreshCw, { className: "mr-2 h-4 w-4" }),
                "Try again"))));
    }
    return React.createElement(React.Fragment, null, children);
};
export default TabSection;
